module.exports = __webpack_public_path__ + "img/22.8a6a305d.jpg";